export default "__VITE_ASSET__Ga8yjxSO__"